import React, { useState, useEffect } from 'react'
import { format } from 'date-fns'
import qs from 'qs'
import styled, { keyframes } from 'styled-components'
import { removeItem } from 'utils/utils'

import serverController from 'server/serverController'
import appInfoContainer from 'auth/appInfoContainer'

import TitleHeader from 'components/presenters/header/TitleHeader'
import MainFeed from 'components/containers/feed/MainFeed'
import { useSelector } from 'react-redux'

export default function ArchiveListLayout({ match }) {
  const userInfo = useSelector((state) => {
    return state.userInfo
  })
  const [archive, setArchive] = useState({})
  const [lastPosNo, setLastPosNo] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isEnd, setIsEnd] = useState(false)
  const [currNo, setCurrNo] = useState(null)
  const [showArchiveDetail, setShowArchiveDetail] = useState(false)

  useEffect(() => {
    loadNextArchiveList()
  }, [])
  useEffect(() => {
    if (currNo) {
      setShowArchiveDetail(true)
    } else {
      setTimeout(() => {
        setShowArchiveDetail(false)
      }, 180)
    }
  }, [currNo])

  const loadNextArchiveList = () => {
    if (!isEnd && !isLoading) {
      setIsLoading(true)
      let queryString = qs.stringify({ limit: 20, last_pos_no: lastPosNo })
      serverController.getServerData(
        `users/${userInfo['id']}/archive?${queryString}`,
        function (res) {
          if (res.success !== 1 || res.data.archive.length === 0) {
            setIsEnd(true)
            setIsLoading(false)
            return
          }

          let tempList = JSON.parse(JSON.stringify(archive))
          res.data.archive.map((value) => {
            let date = format(new Date(value.modify_date), 'yyyy.MM.dd')
            if (tempList[date]) tempList[date].push(value)
            else tempList[date] = [value]
          })

          setArchive(tempList)

          let archiveArray = res.data.archive
          setLastPosNo(
            archiveArray[archiveArray.length - 1].length == 0
              ? 0
              : archiveArray[archiveArray.length - 1].no,
          )
          setIsLoading(false)
        },
      )
    }
  }

  const getArchiveList = () => {
    let list = []

    for (const [key, value] of Object.entries(archive)) {
      list.push(
        <Feedtit key={`archive-date-val-${key}`}>
          {format(new Date(value[0].modify_date), 'yyyy.MM.dd')}
        </Feedtit>,
      )
      value.map((value) => {
        const imagePath = `${appInfoContainer.imagePath}/task_img/${value.proof[0]}`

        list.push(
          <Imglist key={`archive-task-list-item-${value['no']}`}>
            <Galleryimg
              onClick={() => {
                setCurrNo(value.no)
              }}
              to={`/archive/${value.no}`}
            >
              <img src={imagePath} alt="" />
            </Galleryimg>
          </Imglist>,
        )
      })
    }
    return list
  }

  const handleScroll = (e) => {
    if (!isEnd && !isLoading) {
      const bottom = e.target.scrollHeight - e.target.scrollTop - 100 <= e.target.clientHeight
      if (bottom) {
        loadNextArchiveList()
      }
    }
  }
  const editTaskFromList = (targetTask) => {
    let newArchiveList = Object.assign({}, archive)

    for (let key of Object.keys(newArchiveList)) {
      const resultList = newArchiveList[key]
      for (let i = 0; i < resultList.length; ++i) {
        if (parseInt(resultList[i]['task_no']) === parseInt(targetTask['task_no'])) {
          newArchiveList[key][i] = targetTask
        }
      }
    }

    setArchive(newArchiveList)
  }
  const removeTaskFromList = (taskNo) => {
    let newArchiveList = Object.assign({}, archive)
    for (let key of Object.keys(newArchiveList)) {
      const resultList = newArchiveList[key]
      for (let i = 0; i < resultList.length; ++i) {
        if (parseInt(resultList[i]['task_no']) === parseInt(taskNo)) {
          newArchiveList[key] = removeItem(resultList, i)
          if (newArchiveList[key].length === 0) {
            delete newArchiveList[key]
          }
        }
      }
    }

    setArchive(newArchiveList)
  }

  return (
    <FeedInner>
      <ArchiveListWrapper className={currNo ? 'disabled' : null}>
        <HeaderWrapper>
          <TitleHeader title={'인증 기록'} borderbottom={'solid calc(100vw*(1/375)) #d5d5d5'} />
        </HeaderWrapper>
        <ListWrapper>
          <Feedimglist onScroll={handleScroll} className={currNo ? 'disabled' : null}>
            {getArchiveList()}
            <DummySpacer></DummySpacer>
          </Feedimglist>
        </ListWrapper>
      </ArchiveListWrapper>
      {showArchiveDetail ? (
        <DetailArchiveListWrapper
          hideList={currNo === null}
          className={currNo ? 'slide_on' : 'slide_out'}
        >
          <HeaderWrapper>
            <TitleHeader
              animation={true}
              isSlideOn={currNo ? true : false}
              onBackBtn={() => {
                setCurrNo(null)
              }}
              title={'인증 기록'}
              borderbottom={'solid calc(100vw*(1/375)) #d5d5d5'}
            />
          </HeaderWrapper>
          <ListWrapper>
            <MainFeed
              type={'archive'}
              params={{ taskNo: currNo }}
              onDelete={(taskNo) => {
                removeTaskFromList(taskNo)
              }}
              onEdit={(targetTask) => {
                editTaskFromList(targetTask)
              }}
            />
          </ListWrapper>
        </DetailArchiveListWrapper>
      ) : null}
    </FeedInner>
  )
}

const slideOn = keyframes`
    from {
        right: -100%;
        left: 100%;
    }
    to {
        right: 0%;
        left: 0%;
    }
`

const slideOut = keyframes`
    from {
        right: 0%;
        left: 0%;
    }
    to {
        right: -100%;
        left: 100%;
    }
`

const FeedInner = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`
const Feedtit = styled.h1`
  width: 100%;
  height: calc(100vw * (72 / 375));
  font-size: calc(100vw * (18 / 375));
  font-weight: 500;
  padding: calc(100vw * (33 / 375)) calc(100vw * (17 / 375)) 0;
  background-color: #fff;
`
const Feedimglist = styled.ul`
  overflow: scroll;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  background: #fff;
  &.disabled {
    overflow: hidden;
  }
`
const Imglist = styled.li`
  padding: 0 calc(100vw * (2 / 375)) 0 0;
  margin-bottom: calc(100vw * (2 / 375));
  width: 32.94%;
  box-sizing: revert;
  height: calc(100vw * (124 / 375));

  &:nth-child(3n) {
    padding-right: 0;
  }
  & img {
    object-fit: cover;
    height: 100%;
  }
`
const Galleryimg = styled.div`
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
`
const ArchiveListWrapper = styled.div`
  z-index: 450;
  height: 100%;
  display: flex;
  flex-direction: column;
  &.disabled {
    opacity: 0;
  }
`
const DetailArchiveListWrapper = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100vh;
  z-index: 500;
  display: flex;
  background: white;
  flex-direction: column;
  opacity: ${(hideList) => {
    return hideList === true ? 0 : 1
  }};
  &.slide_on {
    animation: 0.2s ease 0s 1 normal none running ${slideOn};
  }

  &.slide_out {
    animation: ${slideOut} 0.2s;
  }
`
const HeaderWrapper = styled.div`
  flex: 0 1 auto;
  height: calc(100vw * (51 / 375));
  min-height: calc(100vw * (51 / 375));
`
const ListWrapper = styled.div`
  flex: 1 1 auto;
  height: 100%;
  overflow: hidden;
`
const DummySpacer = styled.div`
  height: 30px;
  width: 100%;
`
